// src/app/views/pages_predict_admin/score_stat_detail/rtPrAdScoreStatDetail.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { EXAM_TYPES } from "app/types/examTypes";

const ScoreStatDetail_LEET = Loadable(lazy(() => import("./ScoreStatDetail_LEET")));
const ScoreStatDetail_G5 = Loadable(lazy(() => import("./ScoreStatDetail_G5")));
const ScoreStatDetail_G7 = Loadable(lazy(() => import("./ScoreStatDetail_G7")));

const rtPrAdScoreStatDetail = [
  { path: `pre/${EXAM_TYPES.LEET.rid_cd_ext}/score-stat-detail`, element: <ScoreStatDetail_LEET /> },
  { path: `pre/${EXAM_TYPES.G5.rid_cd_ext}/score-stat-detail`, element: <ScoreStatDetail_G5 /> },
  { path: `pre/${EXAM_TYPES.G7.rid_cd_ext}/score-stat-detail`, element: <ScoreStatDetail_G7 /> },
];
export default rtPrAdScoreStatDetail;
